let player;
let haveIDs = false;
var $ = jQuery;

function onPlayerReady(event) {
  event.target.cuePlaylist({
    listType: 'playlist',
    list: playlistId,
    suggestedQuality: 'small',
    autoplay: 1,
    index: 0,
    controls: 0,
  });
  event.target.setLoop();
}

function getCurrentIdx() {
  const activeIdx = document.querySelector('.active.thumb-container:not(.slick-cloned)');

  let idx;
  if (!activeIdx) {
    idx = 0;
  } else {
    idx = activeIdx.getAttribute('data-index');
  }
  return idx;
}

function setActivePLAYING() {
  const idx = getCurrentIdx();
  const containers = document.querySelectorAll('.thumb-container:not(.slick-cloned)');
  const playerWrapper = document.querySelector('.player--wrapper');
  const activeContainer = containers[idx];
  if (activeContainer) {
    activeContainer.classList.add('active');
    if (window.innerWidth >= 1280) {
      activeContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    } else {
      playerWrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }
}

function setActiveENDED(player) {
  const idx = getCurrentIdx();
  const currentPlaylist = JSON.parse(localStorage.getItem('playListArr'));
  const nextIndex = Number(idx) !== currentPlaylist.length - 1 ? Number(idx) + 1 : 0;
  const containers = document.querySelectorAll('.thumb-container:not(.slick-cloned)');
  const playerWrapper = document.querySelector('.player--wrapper');

  containers.forEach(function (container) {
    container.classList.remove('active');
  });

  containers[nextIndex].classList.add('active');

  if (containers[nextIndex]) {
    if (window.innerWidth >= 1280) {
      containers[nextIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    } else {
      playerWrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

  player.cueVideoById(currentPlaylist[nextIndex]);
  player.playVideo();
}

function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.CUED) {
    if (!haveIDs) {
      addClickEvents(player);
      // Initialize the first video as active.
      const containers = document.querySelectorAll('.thumb-container:not(.slick-cloned)');
      const activeContainer = containers[0];
      if (activeContainer) {
        activeContainer.classList.add('active');
      }
    }
  }
  if (event.data == YT.PlayerState.PLAYING) {
    setActivePLAYING();
  }
  if (event.data == YT.PlayerState.ENDED) {
    setActiveENDED(player);
  }
}

const addClickEvents = player => {
  haveIDs = true;
  const containers = document.querySelectorAll('.thumb-container:not(.slick-cloned)');
  containers.forEach(container => {
    container.addEventListener('click', event => {
      // Remove all active class on click
      containers.forEach(container => {
        container.classList.remove('active');
      });

      const playerWrapper = document.querySelector('.player--wrapper');

      player.cueVideoById(event.target.getAttribute('data-id'));
      player.playVideo();

      event.target.classList.add('active');

      if (container) {
        if (window.innerWidth >= 1280) {
          event.target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        } else {
          playerWrapper.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        }
      }
    });
  });
};

const videoSlick = () => {
  $('.image--list-loop')
    .not('.slick-initialized')
    .slick({
      dots: false,
      nextArrow: '.video--flex-middle .buttons--container .next-container',
      prevArrow: '.video--flex-middle .buttons--container .prev-container',
      slidesToShow: 4,
      slidesToScroll: 4,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
};

const youtube = () => {
  const key = 'AIzaSyA_vayNPz64k0jt60_vjh1a02uZLJSsHug';
  playlistId = playlistId ? playlistId : 'PLBs6_t5NjudQ4mYQGNbUVrH8Vef_QmkPg';
  $.get(
    'https://www.googleapis.com/youtube/v3/playlistItems',
    {
      part: 'snippet',
      playlistId: playlistId,
      maxResults: 50,
      key: key,
    },
    data => {
      const imageCont = document.getElementById('images');
      let html;
      let videoArr = [];

      const getSrc = thumbnails => {
        if (thumbnails.maxres) {
          return thumbnails.maxres.url;
        } else if (thumbnails.high) {
          return thumbnails.high.url;
        } else if (thumbnails.medium) {
          return thumbnails.medium.url;
        } else {
          if (thumbnails.default) {
            return thumbnails.default.url;
          }
        }
      };

      data.items.forEach(({snippet}, index) => {
        const imgSrc = getSrc(snippet.thumbnails);

        if (!imgSrc) return;

        videoArr.push(snippet.resourceId.videoId);

        html = `<div data-id="${snippet.resourceId.videoId}" data-index="${index}" class="thumb-container">
              <div class="image-item">
                <img src="${imgSrc}" class="image-play-button">
              </div>
              <div class="title-item">
                <span class="title-span">${snippet.title}</span>
              </div>
            </div>`;

        imageCont.appendChild(document.createRange().createContextualFragment(html));
      });

      localStorage.setItem('playListArr', JSON.stringify(videoArr));

      window.addEventListener(
        'resize',
        _.debounce(() => {
          if (window.innerWidth >= 1280) {
            $('.image--list-loop').slick('unslick');
          } else {
            videoSlick();
          }
        }, 250)
      );

      if (window.innerWidth <= 1280) {
        videoSlick();
      }
    }
  );
};

function initYoutubeElement(target) {
  if (YT.loaded) {
    player = new YT.Player(target, {
      height: '390',
      width: '640',
      playerVars: {
        controls: 1,
        showinfo: 0,
        rel: 0,
        showsearch: 0,
        iv_load_policy: 3,
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  }
}

const ytPlayer = {
  init: () => {
    const elements = document.querySelectorAll('#player');
    const youtubeSlick = document.querySelectorAll('.grid--small-container .video--flex-bottom');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.target.getAttribute('id') === 'player') {
          initYoutubeElement(entry.target);
        }

        if (entry.isIntersecting && entry.target.classList.contains('video--flex-bottom') && !entry.target.classList.contains('init')) {
          entry.target.classList.add('init')
          youtube();
        }
      });
    });

    if (youtubeSlick && youtubeSlick.length) {
      youtubeSlick.forEach((slickElement) => {
        observer.observe(slickElement);
      });
    }

    if (elements && elements.length) {
      elements.forEach((element) => {
        observer.observe(element);
      });
    }
  }
};

// Load JS
const init = ytPlayer.init;

export {init};
